import React from 'react';
import useLanguage from '../../hooks/useLanguage';
import companyData from '../../data/company.json';
import translationsData from '../../data/translations.json';
import { FiCheckCircle } from 'react-icons/fi';

/**
 * Timeline Component
 * Displays company history as a vertical timeline
 */
const Timeline = () => {
  const { language } = useLanguage();

  const historyTitle = language === 'ko' ? translationsData.titles.history : translationsData.titles.historyEn;

  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Title */}
        <div className="text-center mb-12" data-aos="fade-up">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {historyTitle}
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Vertical Line */}
          <div className="absolute left-8 md:left-1/2 top-0 bottom-0 w-1 bg-blue-200 transform md:-translate-x-1/2"></div>

          {/* Timeline Items */}
          <div className="space-y-12">
            {companyData.history.map((item, index) => (
              <div
                key={index}
                className={`relative flex items-center ${
                  index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                {/* Timeline Dot */}
                <div className="absolute left-8 md:left-1/2 w-4 h-4 bg-blue-600 rounded-full transform -translate-x-1/2 z-10 flex items-center justify-center">
                  <FiCheckCircle className="w-8 h-8 text-blue-600 bg-white rounded-full" />
                </div>

                {/* Content Card */}
                <div className={`w-full md:w-5/12 ml-20 md:ml-0 ${index % 2 === 0 ? 'md:pr-12' : 'md:pl-12'}`}>
                  <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
                    {/* Year */}
                    <div className="inline-block bg-blue-600 text-white px-4 py-1 rounded-full text-lg font-bold mb-3">
                      {item.year}
                    </div>
                    {/* Event Description */}
                    <p className="text-gray-700 leading-relaxed">
                      {language === 'ko' ? item.event : item.eventEn}
                    </p>
                  </div>
                </div>

                {/* Spacer for alternating layout on desktop */}
                <div className="hidden md:block w-5/12"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Timeline;
